export enum LaunchEvents {
    SHOW_MODAL = 'launch/show',
    HIDE_MODAL = 'launch/hide',
}

export type LaunchModalOptions = {
    surveyId: string | number;
    isMultiMarket?: boolean;
    surveyIds?: (string | number)[];
};

export const showLaunchModal = (options: Partial<LaunchModalOptions> = {}) => {
    const event = new CustomEvent(LaunchEvents.SHOW_MODAL, {
        detail: options,
    });

    window.dispatchEvent(event);
};

export const hideLaunchModal = () => {
    window.dispatchEvent(new CustomEvent(LaunchEvents.HIDE_MODAL));
};
